<div class="integration-actions">
    <button
        mat-stroked-button
        appPreventDoubleClick (throttledClick)="testConnection()"
        [disabled]="isTesting"
    >
        <mat-spinner *ngIf="isTesting" class="button-spinner" [diameter]="18"></mat-spinner>
        <mat-icon *ngIf="!isTesting" class="material-icons-outlined">network_check</mat-icon>
        <ng-container *ngIf="isTesting; else testLabel">{{ 'Testing-Connection' | translate: {Default: 'Testing...'} }}</ng-container>
        <ng-template #testLabel>{{ 'Integrations-TestConnection' | translate: {Default: 'Test Connection'} }}</ng-template>
    </button>

    <button
        *ngIf="canRunNow"
        mat-flat-button
        setColor="primaryColour"
        color="primary"
        appPreventDoubleClick (throttledClick)="runNow()"
        [disabled]="isRunning"
    >
        <mat-icon class="material-icons-outlined">play_arrow</mat-icon>
        <ng-container *ngIf="isRunning; else runLabel">{{ 'Integrations-RunningNow' | translate: {Default: 'Running Now...'} }}</ng-container>
        <ng-template #runLabel>{{ 'Integrations-RunNow' | translate: {Default: 'Run Now'} }}</ng-template>
    </button>
</div>
